var Share = function () {

    this.init = function () {

        $('[data-component="share"] .scrollbar-inner').scrollbar();

        $('.cancel').on('click', function () {
            $(this).trigger('modal:close')
        });

        $('#modal-validate').validate({
            ignore: '.ignore',
            errorPlacement: function () {
                return true;
            },
            rules: {
                from: {
                    required: true
                },
                to: {
                    required: true
                },
                email: {
                    required: true,
                    email: true
                }
            },
            submitHandler: function (form) {

                $(form).find(".btn").attr("disabled", true);
                $(form).find(".btn").addClass("loading");

                var ShareNews = {
                    "NewsID": $(form).data("id"),
                    "From": $(form).find("input[name='from']").val(),
                    "To": $(form).find("input[name='to']").val(),
                    "Email": $(form).find("input[name='email']").val()
                };

                $.ajax({
                    type: "POST",
                    url: "/umbraco/surface/News/SendColleague",
                    data: JSON.stringify({ "ShareNews": ShareNews }),
                    dataType: "json",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: function success(response) {

                        $(form).each(function () {
                            this.reset();
                        });
                        $('p.success-message').fadeIn();
                        setTimeout(function () {
                            $('[data-component="share"] p.success-message').fadeOut();
                        }, 5000);

                        $(form).find(".btn").attr("disabled", false);
                        $(form).find(".btn").removeClass("loading");
                    },
                    error: function error(e) {
                        $('p.error-message').fadeIn();
                        setTimeout(function () {
                            $('[data-component="share"] p.error-message').fadeOut();
                        }, 5000);
                    }
                });
            }
        });
    }

    return this.init();
}